











































































































































































































import Vue from "vue";
import BaseLabeledSwitch from "@/app/shared/components/base/BaseLabeledSwitch.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseInputEasy from "@/app/shared/components/base/BaseInputEasy.vue";
import BaseTooltipIcon from "@/app/shared/components/base/BaseTooltipIcon.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import {NamingTemplates} from "../../../models/classes/NamingTemplates";
import draggable from "vuedraggable";
import BaseSelect from "@/app/shared/components/base/BaseSelect.vue";
import {VPopover, VClosePopover, VTooltip} from "v-tooltip";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import _ from "lodash";

export default Vue.extend({
  name: "NameController",
  components: {
    BaseLabeledSwitch,
    BaseInput,
    BaseInputEasy,
    BaseTooltipIcon,
    BaseCheckbox,
    draggable,
    BaseSelect,
    VPopover,
    BaseButton,
  },
  directives: {
    "close-popover": VClosePopover,
    tooltip: VTooltip,
  },
  data: function () {
    return {
      drag: false,
    };
  },
  props: {
    isMultiSelectMode: {
      type: Boolean,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    variationNamingTemplate: {
      // getter
      get: function () {
        return this.$store.state.variationNamingTemplate;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("variationNamingTemplate", newValue);
      },
    },
    defaultVariationNamingTemplate: {
      // getter
      get: function () {
        return this.$store.state.defaultVariationNamingTemplate;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("defaultVariationNamingTemplate", newValue);
      },
    },
    possibleSuffixes: function () {
      return NamingTemplates.namingTemplateSuffixes.filter(
        (s) =>
          s.name === "custom" ||
          !this.previewItem.currentVariation.outputNameTemplate.some(
            (suf) => suf.name === s.name
          )
      );
    },
    isInHouse: function () {
      return this.$store.state.userInfo.isInHouse;
    },
    currentVariationName: function () {
      let variationName = NamingTemplates.getVariationOutputFileName(
        this.previewItem.currentVariation,
        this.$store.state.items.indexOf(this.$store.state.selectedItem) + 1,
        this.$store.state.items
          .reduce((acc, val) => acc.concat(val.variations), [])
          .indexOf(this.previewItem.currentVariation) + 1,
        this.isInHouse
      );
      return variationName;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
        filter: [
          ".base-input",
          ".base-select",
          ".base-select-footer",
          ".base-input-easy",
        ].join(","),
        preventOnFilter: false,
      };
    },
  },
  methods: {
    getSuffixValues(suffixName) {
      return NamingTemplates.namingTemplateSuffixes.find((s) => s.name === suffixName).values;
    },
    addNewSuffix(suffix) {
      setTimeout(() => {
        let newSuffix = NamingTemplates.getNewSuffixByName(suffix.name);
        if (this.previewItem.currentVariation.checked) {
          this.items.forEach((item) => {
            item.variations.forEach((v) => {
              if (v.checked) {
                let suffixExist = false
                v.outputNameTemplate.forEach((existingSuffix) => {
                  if (newSuffix.name === existingSuffix.name && newSuffix.name !== 'custom') {
                    suffixExist = true
                  }
                })
                if (!suffixExist) {
                  v.outputNameTemplate.push(JSON.parse(JSON.stringify(newSuffix)));
                }
              }
            });
          });
        } else {
          this.items.forEach((item) => {
            item.currentVariation.outputNameTemplate.push(JSON.parse(JSON.stringify(newSuffix)))
          })
        }
        this.variationNamingTemplate.push(
          JSON.parse(JSON.stringify(newSuffix))
        );
      }, 10);
      this.updateVariationNamingTemplate(
        this.previewItem.currentVariation.outputNameTemplate
      );
    },
    deleteSuffix(suffix) {
      let deleteIndex =
        this.previewItem.currentVariation.outputNameTemplate.indexOf(suffix);
      if (this.previewItem.currentVariation.checked) {
        this.items.forEach((item) => {
          item.variations.forEach((v) => {
            v.outputNameTemplate.splice(deleteIndex, 1);
          });
        });
      } else {
        this.previewItem.currentVariation.outputNameTemplate.splice(
          deleteIndex,
          1
        );
      }

      this.variationNamingTemplate.splice(deleteIndex, 1);
      this.updateVariationNamingTemplate(
        this.previewItem.currentVariation.outputNameTemplate
      );
    },
    onChangeSuffix(suffix) {
      this.changeCheckedItems(suffix);
      let index =
        this.previewItem.currentVariation.outputNameTemplate.indexOf(suffix);
      this.variationNamingTemplate[index].value = _.cloneDeep(suffix.value);
      this.updateVariationNamingTemplate(
        this.previewItem.currentVariation.outputNameTemplate
      );
    },
    dragEnd(e) {
      this.drag = false;
      if (this.previewItem.currentVariation.checked) {
        this.items.forEach((item) => {
          item.variations.forEach((v) => {
            if (v === this.previewItem.currentVariation) {
              return;
            }
            if (v.checked) {
              this.moveArrayItemToNewIndex(
                v.outputNameTemplate,
                e.oldIndex,
                e.newIndex
              );
            }
          });
        });
      }
      this.moveArrayItemToNewIndex(
        this.variationNamingTemplate,
        e.oldIndex,
        e.newIndex
      );
      this.updateVariationNamingTemplate(
        this.previewItem.currentVariation.outputNameTemplate
      );
    },
    moveArrayItemToNewIndex(array, fromIndex, toIndex) {
      array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
    },
    updateVariationNamingTemplate(template) {
      this.variationNamingTemplate.forEach((suffix) => {
        let testVariable = template.find((s) => s.id === suffix.id)
        if (testVariable !== undefined) {
          suffix.value = testVariable.value
        } else {
          console.warn('(-) Something goes wrong...')
        }
      });
    },
    saveAsDefault() {
      this.defaultVariationNamingTemplate = _.cloneDeep(
        this.variationNamingTemplate
      );
    },
    resetToDefault() {
      this.variationNamingTemplate = _.cloneDeep(
        this.defaultVariationNamingTemplate
      );
      this.previewItem.currentVariation.outputNameTemplate = _.cloneDeep(
        this.variationNamingTemplate
      );
      this.changeCheckedItems(null, false, true);
    },
    changeCheckedItems(suffix, isOriginalName, isAllTemplate) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }
          if (suffix) {
            if (suffix.name === 'custom') {
              let currentCustomSuffixId = suffix.id
              v.outputNameTemplate.forEach((nameTemplate) => {
                if (nameTemplate.id === currentCustomSuffixId) {
                  nameTemplate.value = _.cloneDeep(suffix.value)
                }
              })
            } else {
              let index = this.previewItem.currentVariation.outputNameTemplate.indexOf(suffix);
              v.outputNameTemplate[index].value = _.cloneDeep(suffix.value);
            }
          }
          if (isOriginalName && !item.isFromUA) {
            v.isSaveOriginalName =
              this.previewItem.currentVariation.isSaveOriginalName;
          }
          if (isAllTemplate) {
            v.outputNameTemplate = _.cloneDeep(
              this.previewItem.currentVariation.outputNameTemplate
            );
          }
        });
      });
    },
  },
});
